import config from '@/config/config.js';
import { http } from '@/common/request';
import errorCode from '@/api/error-code.js'
export default {
    /***************************************************** start *******************************************/



    getKefuGroupInfo(){
        let params = { }
        let data = {};
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/common/groupFoodKefuInfo",data, method: 'GET', ...options});
    },



    getHomeBanners(){
        let params = { }
        let data = {};
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/common/banner/home",data, method: 'GET', ...options});
    },

    getHomeActivity(){
        let params = { }
        let data = {};
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/common/banner/getActivityInfo",data, method: 'GET', ...options});
    },

    productCats(catId){
        let params = {
            catId: catId,
        }
        let data = {
        }
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/common/product/productCats",data, method: 'GET', ...options});
    },

    articleCats(){
        let params = {

        }
        let data = {
        }
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/common/article/cats",data, method: 'GET', ...options});
    },

    articleDetail(articleId){
        let params = {
            articleId:articleId
        }
        let data = {
        }
        const options = {};
        options.params = params;
        return  http.request({url:"/api/v3/common/article/detail",data, method: 'GET', ...options});
    },




    /***************************************************** end *********************************************/
}
